import React, { ReactElement } from 'react'
import { ThemeProvider, createTheme } from '@material-ui/core/styles'
import CssBaseline from '@material-ui/core/CssBaseline'

export interface ThemeBaseProps {
  children: ReactElement | ReactElement[]
}

export const theme = createTheme({
  palette: {
    type: 'light',
    primary: {
      main: '#388087'
    }
  }
})

function ThemeBase({ children }: ThemeBaseProps): ReactElement {
  return (
    <ThemeProvider theme={theme}>
      {children}
      <CssBaseline />
    </ThemeProvider>
  )
}

export default ThemeBase
